import * as React from 'react';

import { Alert } from '@ui';
import toast, { ToastOptions } from 'react-hot-toast';

export type Severity = 'error' | 'warning' | 'success' | 'info' | 'none';

export const contactSupportMessage = (
    <>
        If this continues to happen, please email our support desk at{' '}
        <a href={'mailto:support@spotlightreporting.com'}>support@spotlightreporting.com</a>
    </>
);

export const genericErrorMessage = <p>Sorry, something went wrong. {contactSupportMessage}.</p>;

export const showToastAlert = ({
    severity,
    content,
    duration,
    dataId,
    maxWidth = '500px',
    options = {},
}: {
    severity: Severity;
    content: React.ReactNode;
    // TODO: remove the duration prop and use options.duration instead
    duration?: number;
    dataId?: string;
    maxWidth?: string;
    options?: ToastOptions;
}): void => {
    const display = () => {
        toast.custom(
            (t) => (
                <Alert
                    onDismiss={() => toast.dismiss(t.id)}
                    isVisible={t.visible}
                    variant={'shadowed'}
                    severity={severity}
                    maxWidth={maxWidth}
                    dataId={dataId}
                    fadeIn
                >
                    {content}
                </Alert>
            ),
            {
                position: 'top-center',
                duration: duration ?? Infinity,
                ...options,
            },
        );
    };

    if (options?.id) {
        toast.remove(options.id);
        // Allow time for the existing toast to be removed before showing a new one
        setTimeout(display, 100);
    } else {
        display();
    }
};

export const showGenericErrorToast = (): void => {
    showToastAlert({
        severity: 'error',
        content: genericErrorMessage,
    });
};
